import Request from "./request";
import consts from "@/consts.js";
// 线路管理
async function fetch(data) {
  return Request("get", "api/distribution-users/", data);
}

async function fetchAll(data) {
  if (!data) data = {};
  data.limit = consts.limitAll; //获取全部
  return Request('get', "api/distribution-users", data);
}

async function fetchAllForSelect(data) {
  if (!data) data = {};
  data.limit = consts.limitAll; //获取全部
  return Request('get', "api/distribution-users/select", data, false, false, true);
}
// 根据 id 筛选
async function fetchSelected(id,data) {
  if (!data) data = {};
  data.limit = consts.limitAll; //获取全部
  return Request("get", "api/distribution-users/?stock_id=" + id,data);
}

// 删除数据
async function del(id) {
  return Request("delete", "api/distribution-users/delete/" + id);
}

// 编辑或新建（有id为编辑，没有id为新建）
async function save(id, data) {
  if (id) {
    return Request("post", "api/distribution-users/edit?id=" + id, data);
  } else {
    return Request("post", "api/distribution-users/add", data);
  }
}

export default {
  fetch,
  fetchSelected,
  del,
  save,
  fetchAll,
  fetchAllForSelect
};
